import { t } from "@lingui/macro";
import React, { ReactElement, ReactNode } from "react";
import { v4 as uuidv4 } from "uuid";

import { AlertIcon } from "../../icons_v2/general";
import { Box, Text } from "../../primitive";

type FormFieldProps = {
  title?: ReactNode | string;
  isOptional?: boolean;
  control: ReactElement | ReactElement[];
  errorMessage?: string;
  showRequired?: boolean;
};

export const FormField = ({
  title,
  isOptional,
  control,
  errorMessage,
  showRequired,
}: FormFieldProps) => {
  const controlSection = Array.isArray(control) ? (
    control.map((item, index) => (
      <Box key={`control-item-${uuidv4()}`} marginTop={index > 0 ? 2 : 0}>
        {item}
      </Box>
    ))
  ) : (
    <Box>{control}</Box>
  );

  return (
    <Box flex={1}>
      {title ? (
        <Box marginBottom={3} flexDirection="row">
          <Text variant="mainSmallSemiBold">{title}</Text>
          {showRequired && !isOptional ? (
            <Text variant="mainSmallSemiBold">*</Text>
          ) : null}
          {isOptional ? (
            <Text
              marginLeft={1}
              variant="mainSmallSemiBold"
              color="text-secondary"
            >
              {t`(Optional)`}
            </Text>
          ) : null}
        </Box>
      ) : null}
      <Box flex={1}>{controlSection}</Box>
      {errorMessage && errorMessage?.length ? (
        <Box marginTop={1}>
          <Box flexDirection="row" gap={1}>
            <AlertIcon color="icon-status-error" />
            <Text variant="mainTiny" color="text-error">
              {errorMessage}
            </Text>
          </Box>
        </Box>
      ) : null}
    </Box>
  );
};
